module.exports = __webpack_public_path__ + "img/account-switch.d62e1ff6.svg";